module.exports = __webpack_public_path__ + "img/493.5a4605d9.jpg";